import { render, staticRenderFns } from "./DraftPage.vue?vue&type=template&id=b63a3cd4&scoped=true&"
import script from "./DraftPage.vue?vue&type=script&lang=ts&"
export * from "./DraftPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63a3cd4",
  null
  
)

export default component.exports